function stringifyAttributes(htmlAttributes = {}) {
    return Object.keys(htmlAttributes)
        .reduce((previous, current) => {
            return `${previous} ${current}="${htmlAttributes[current]}"`;
        }, '')
        .trim();
}

export default stringifyAttributes;
